const convertToEnglishNumber = (number) => {
  return number.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
};

export default convertToEnglishNumber;
